import { FiMenu, FiX } from "react-icons/fi";
import { useState } from "react";

function NavBar(){
     const [menuOpen,setMenuOpen] = useState(false);

    return(
        <div className="navigation-bar" id="About">
          <h3 className="logo">
            <sup>@</sup>Kevin Nguyen
          </h3>
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            {menuOpen ? <FiX/> : <FiMenu/>}
          </div>
          <div className={`single-bar ${menuOpen ? "active" : ""}`}>
            <h3> <a href="#About" className="bar-link"> About me </a></h3>
            <h3> <a href="#project" className="bar-link"> Project </a></h3>
            <h3> <a href="#contact" className="bar-link"> Contact me </a></h3>
          </div>
        </div>
    );
}

export default NavBar;